'use strict';
import
sysvarController from './admin-sysvars.controller';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.admin', {
        url: '/admin',
        templateUrl: 'app/admin/admin.html',
        controller: 'AdminCtrl'
      })
      .state('authenticated.admin-sysvars-general', {
        url: '/admin-sysvars/general',
        templateUrl: 'app/admin/admin-sysvars-general.html',
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: "General Settings",
          saveVars: ['season', 'sandbox', 'registrationOpen', 'poolResOpen', 'partyResOpen', 'checkOutSupported']
        }
      })
      .state('authenticated.admin-sysvars-integrations', {
        url: '/admin-sysvars/integrations',
        templateUrl: 'app/admin/admin-sysvars-integrations.html',
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: "Integration Settings",
          saveVars: ['integrations']
        }
      })
      .state('authenticated.admin-sysvars-mailtemplates', {
        url: '/admin-sysvars/mailtemplates',
        templateUrl: 'app/admin/admin-sysvars-mailtemplates.html',
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: "Email Template Settings",
          saveVars: ['activationEmail', 'pwResetEmail', 'emailFooters']
        }
      })
      .state('authenticated.admin-sysvars-reservations', {
        url: '/admin-sysvars/reservations',
        templateUrl: 'app/admin/admin-sysvars-reservations.html',
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: "Reservation Settings",
          saveVars: ['reservations']
        }
      })
      .state('authenticated.admin-sysvars-kiosks', {
        url: '/admin-sysvars/kiosks',
        templateUrl: 'app/admin/admin-sysvars-kiosks.html',
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: "Kiosk Settings",
          saveVars: ['kiosks'],
          validate: [
            { test: 'unique', within: 'kiosks.val', testParams: { field: 'number', fieldDesc: 'Number' } },
          ]
        }
      })
      .state('authenticated.admin-sysvars-products', {
        url: '/admin-sysvars/products',
        template: require('./admin-sysvars-products.html'),
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: 'Products',
          saveVars: ['products'],
          multi: {
            varName: 'products',
            displayField: 'productName',
            orderBy: ['el.groupId', 'el.productName'],
            archivable: true,
            cloneMapper: p => {
              p.price = [];
              p.productCode = (p.productCode || '') + '_COPY';
              p.productName = 'COPY';
              return p;
            }
          },
          validate: [
            { test: 'unique', within: 'products.val', testParams: { field: 'productCode', fieldDesc: 'Group ID' } },
            { test: 'unique', within: 'products.val', testParams: { field: 'productName', fieldDesc: 'Group Name' } },
            { across: 'products.val', test: 'noDateOverlap', within: 'price', key: 'productCode' }
          ]
        }
      })
      .state('authenticated.admin-sysvars-productgroups', {
        url: '/admin-sysvars/productgroups',
        template: require('./admin-sysvars-productgroups.html'),
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: 'Product Groups',
          saveVars: ['productGroups'],
          multi: {
            varName: 'productGroups',
            displayField: 'groupName'
          },
          validate: [
            { test: 'unique', within: 'productGroups.val', testParams: { field: 'groupId', fieldDesc: 'Group ID' } },
            { test: 'unique', within: 'productGroups.val', testParams: { field: 'groupName', fieldDesc: 'Group Name' } }
          ]
        }
      })
      .state('authenticated.admin-sysvars-accounttypes', {
        url: '/admin-sysvars/accounttypes',
        template: require('./admin-sysvars-keyval.html'),
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: 'Account Types',
          saveVars: ['accountTypes'],
          keyVal: 'accountTypes'
        }
      })
      .state('authenticated.admin-sysvars-smstypes', {
        url: '/admin-sysvars/smstypes',
        template: require('./admin-sysvars-keyval.html'),
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: 'SMS Types',
          saveVars: ['sMSTypes'],
          keyVal: 'sMSTypes'
        }
      })
      .state('authenticated.admin-sysvars-policies', {
        url: '/admin-sysvars/policies',
        template: require('./admin-sysvars-policies.html'),
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: 'Policies',
          saveVars: ['policies'],
          multi: {
            varName: 'policies',
            displayField: 'title'
          },
          validate: [
            { test: 'unique', within: 'policies.val', testParams: { field: 'policyId', fieldDesc: 'Policy ID' } },
            { test: 'unique', within: 'policies.val', testParams: { field: 'title', fieldDesc: 'Policy Name' } }
          ]
        }
      })
      .state('authenticated.admin-sysvars-votes', {
        url: '/admin-sysvars/votes',
        template: require('./admin-sysvars-votes.html'),
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: 'Votes & Surveys',
          saveVars: ['votesSurveys'],
        }
      })
      .state('authenticated.admin-sysvars-selfsignup', {
        url: '/admin-sysvars/selfsignup',
        template: require('./admin-sysvars-selfsignup.html'),
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: 'Self-Signup Configuration',
          saveVars: ['selfSignup'],
        }
      })
      .state('authenticated.admin-sysvars-courtReservations', {
        url: '/admin-sysvars/court-reservations',
        templateUrl: 'app/admin/admin-sysvars-courtReservations.html',
        controller: sysvarController,
        controllerAs: '$ctrl',
        data: {
          heading: "Court Reservation Settings",
          saveVars: ['courtReservations']
        }
      });
  });

